
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showModal } from "../../../features/modal/modalSlice";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import Btn from "../../shared/button/Btn";
import { deleteBolgeTeklifItem } from "../../../features/bolgedekiTekliflerim/bolgedekiTekliflerimSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;
  .modal {
    width: 600px;
    max-height: 600px;
    overflow: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;

    .content {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 50px;
      flex-direction: column;
      justify-content: space-between;

      p{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: ${({theme}) => theme.mainTextColor};
        text-align: center;
      }

      .btn-container{
        display: flex;
        justify-content: center;
        gap: 20px;
        margin-top: 30px;


      }


    }
  }
`;

const DeletePermissionBolgedekiTeklifItemModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { modalLocation } = useSelector((state) => state.modal);

  const {bolgedekiTeklifItem} = useSelector(state => state.bolgedekiTekliflerim)
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  return (
    <Container  onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
        <div className="content">
            <p>Girilen Teklifi silmek istediğinize emin misiniz?</p>

            <div className="btn-container">
                <Btn bgColor="#E85546" color="#fff" width={"220px"} handleClick={() => dispatch(deleteBolgeTeklifItem(bolgedekiTeklifItem.id))}>Sil</Btn>
                <Btn bgColor="#fff" color="#E85546" borderColor="#E85546" width={"220px"} handleClick={() => dispatch(showModal(null))}>Geri</Btn>
            </div>
        </div>
      </div>
    </Container>
  );
};

export default DeletePermissionBolgedekiTeklifItemModal